/*
 * Channel.io ランチャー位置調整
 *
 * 商品ページのバリアント選択モーダル（Color / Size）が開いている間、
 * Channel.io の Q&A ランチャー（左下に常時表示されるチャットアイコン）が
 * モーダル内のサイズ表記と重なって選びづらくなる問題への対処。
 *
 * バリアント選択モーダルが開いている時のみ、ランチャーをヘッダー直下に
 * 一時退避する。閉じれば元の位置（左下）へ自動復帰する。
 *
 * 実装メモ:
 *   Channel.io ランチャーは Shadow DOM (open) 内で styled-components により
 *   レンダリングされ、外部スタイルシートからは触れない。Shadow Root に
 *   <style> を直接 append/remove することで CSS 上書きを実現する。
 *   参考: 社内ナレッジ「Shadow DOMについて」
 *
 * 関連: Issue #70
 */
(function () {
  'use strict';

  // 重複読み込み防止: 万一 theme.liquid 以外からも include された場合、
  // Observer が二重に起動するのを防ぐ
  if (window.__asjChannelLauncherShiftLoaded) return;
  window.__asjChannelLauncherShiftLoaded = true;

  var STYLE_ID = 'asj-channel-launcher-shift';
  // top: 80px の根拠 = ヘッダー高 61px (sticky) + ロゴ下の余白 19px。
  // ヘッダーデザインを大きく変える際は連動して見直すこと。
  var SHIFT_CSS =
    '[data-ch-testid="launcher"] {' +
    '  top: 80px !important;' +
    '  bottom: auto !important;' +
    '  transition: top 0.2s ease, bottom 0.2s ease;' +
    '}';

  function findChannelShadowRoot() {
    var entry = document.getElementById('ch-plugin-entry');
    if (!entry) return null;
    for (var i = 0; i < entry.children.length; i++) {
      var child = entry.children[i];
      if (child.shadowRoot && child.shadowRoot.querySelector('[data-ch-testid="launcher"]')) {
        return child.shadowRoot;
      }
    }
    return null;
  }

  function applyShift(shadowRoot, on) {
    if (!shadowRoot) return;
    var existing = shadowRoot.getElementById(STYLE_ID);
    if (on) {
      if (existing) return;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = SHIFT_CSS;
      shadowRoot.appendChild(style);
    } else if (existing) {
      existing.remove();
    }
  }

  function isVariantPopoverOpen() {
    return !!document.querySelector('x-popover[id*="popover-variant-dropdown"][open]');
  }

  function tick() {
    var sr = findChannelShadowRoot();
    if (!sr) return;
    applyShift(sr, isVariantPopoverOpen());
  }

  // variant popover の open 属性変化を監視
  new MutationObserver(tick).observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['open']
  });

  // Channel.io が後からロードされるケースに備えて #ch-plugin-entry も監視
  var entry = document.getElementById('ch-plugin-entry');
  if (entry) {
    new MutationObserver(tick).observe(entry, { childList: true, subtree: true });
  }

  // 初回適用
  tick();
})();
